// extracted by mini-css-extract-plugin
export default {"app":"View_app"};